<template>
  <table-layout title="ویژگی های محصول" :showSearch="false">
    <template #buttons>
      <router-link :to="{ name: 'TrashFeatures' }">
        <b-button pill variant="danger"> سطل زباله</b-button>
      </router-link>

      <router-link :to="{ name: 'CreateFeature' }">
        <b-button pill variant="purple" class="ml-1 mb-1"
        >ساخت ویژگی جدید
        </b-button
        >
      </router-link>

      <LanguageSelectBox @changeLanguage="getItems" module-name="feature"
                         class="mx-4 d-inline-block"/>

    </template>
    <template #table>
      <tabel-items :items="features" :restoreState="false"/>
      <div class="row pt-3">
        <div class="mt-3 color">
          <pagination :meta="paginationMeta" :on-change-page="changePage"/>
        </div>
      </div>
    </template>
  </table-layout>
</template>

<script>
import {mapGetters} from "vuex";
import TableLayout from "../../components/dashboard/TableLayout";
import Pagination from "../../components/dashboard/Pagination";
import tabelItems from "../../components/dashboard/Feature/tableItems.vue"
import LanguageSelectBox from "../../components/dashboard/Language/LanguageSelectBox";

export default {
  name: "Feature",
  components: {TableLayout, Pagination, tabelItems, LanguageSelectBox},
  mounted() {
    this.getItems()
  },
  computed: {
    ...mapGetters({
      features: "Feature/getFilteredFeatures",
      paginationMeta: "Feature/getPaginationMeta",
    }),
  },
  methods: {
    changePage(page) {
      this.$store.dispatch("Feature/getFeatures", page);
    },
    getItems() {
      this.$store.dispatch("Feature/getFeatures", 1);
    }
  }
};
</script>

<style scoped>
</style>